// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_members_model from "./web_members_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function request(t, body, path, consume, on_error) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, body, path).then(function (result) {
    if (generation === t.generation) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(on_error, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        Curry._1(on_error, result._0);
      }
    }
    return Promise.resolve();
  });
}

function list(t, more) {
  const model = Curry._1(t.model, undefined);
  const suffix = more ? Stdlib__Option.fold("", (function (cursor) {
      return "?after_id=" + cursor;
    }), model.cursor) : "";
  Curry._1(t.emit, /* Loading */ 5);
  request(t, undefined, Curry._1(t.path, undefined) + suffix, (function (json) {
    const epoch = Mapre_wire__Json.integer(json, "membership_epoch");
    if (more && model.epoch !== epoch) {
      return Curry._1(t.emit, {
        TAG: /* Failed */ 4,
        _0: "Membership changed. Refresh the member list.",
        _1: false
      });
    } else {
      return Curry._1(t.emit, {
        TAG: /* Listed */ 3,
        _0: Stdlib__List.map(Mapre_web__Web_members_model.decode, Stdlib__Array.to_list(Mapre_wire__Json.array(json, "members"))),
        _1: epoch,
        _2: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "next_cursor")),
        _3: more
      });
    }
  }), (function (error) {
    Curry._1(t.emit, {
      TAG: /* Failed */ 4,
      _0: "Unable to load workspace members.",
      _1: false
    });
    Curry._1(t.failure, error);
  }));
}

function send(t, operation) {
  Curry._1(t.emit, {
    TAG: /* Pending */ 2,
    _0: operation
  });
  request(t, Mapre_web__Web_members_model.body(operation), Curry._1(t.path, undefined) + ("/" + operation.member.user_id), (function (param) {
    Curry._1(t.emit, /* Succeeded */ 6);
    list(t, false);
  }), (function (error) {
    let exit = 0;
    if (/* tag */ typeof error !== "object" && typeof error !== "function") {
      exit = error === /* Invalid_response */ 2 ? 1 : 2;
    } else if (error.TAG === /* Failed */ 1) {
      if (error._0 === "membership_conflict") {
        Curry._1(t.emit, {
          TAG: /* Failed */ 4,
          _0: "Membership changed. Review the refreshed list.",
          _1: false
        });
        return list(t, false);
      }
      exit = 1;
    } else {
      exit = 2;
    }
    switch (exit) {
      case 1 :
        let uncertain;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          uncertain = error === /* Invalid_response */ 2 ? true : false;
        } else if (error.TAG === /* Failed */ 1) {
          switch (error._0) {
            case "Connection unavailable. Retry when online." :
            case "membership_change_uncertain" :
              uncertain = true;
              break;
            default:
              uncertain = false;
          }
        } else {
          uncertain = false;
        }
        return Curry._1(t.emit, {
          TAG: /* Failed */ 4,
          _0: uncertain ? "Change result unknown. Retry to confirm." : "Unable to change membership.",
          _1: uncertain
        });
      case 2 :
        Curry._1(t.emit, {
          TAG: /* Failed */ 4,
          _0: "Permission denied. Your workspace role changed.",
          _1: false
        });
        return Curry._1(t.failure, error);
    }
  }));
}

function change(t, member, role) {
  const model = Curry._1(t.model, undefined);
  if (Curry._1(t.allowed, undefined) && !model.busy && model.pending === undefined && !model.loading) {
    return send(t, {
      member,
      role,
      request_id: crypto.randomUUID(),
      epoch: model.epoch
    });
  }
  
}

function dispatch(t, member) {
  if (/* tag */ typeof member !== "object" && typeof member !== "function") {
    switch (member) {
      case /* Refresh */ 0 :
        if (!Curry._1(t.model, undefined).busy && Curry._1(t.model, undefined).pending === undefined) {
          return list(t, false);
        } else {
          return;
        }
      case /* More */ 1 :
        if (!Curry._1(t.model, undefined).loading && !Curry._1(t.model, undefined).busy && Curry._1(t.model, undefined).pending === undefined && Curry._1(t.model, undefined).cursor !== undefined) {
          return list(t, true);
        } else {
          return;
        }
      case /* Confirm */ 2 :
        return Stdlib__Option.iter((function (member) {
          change(t, member, "remove");
        }), Curry._1(t.model, undefined).confirm);
      case /* Cancel */ 3 :
        return Curry._1(t.emit, /* Cancel */ 3);
      case /* Retry */ 4 :
        if (!Curry._1(t.model, undefined).busy && Curry._1(t.allowed, undefined)) {
          return Stdlib__Option.iter((function (param) {
            return send(t, param);
          }), Curry._1(t.model, undefined).pending);
        } else {
          return;
        }
      default:
        return;
    }
  } else {
    switch (member.TAG) {
      case /* Change */ 0 :
        return change(t, member._0, member._1);
      case /* Remove */ 1 :
        if (Curry._1(t.model, undefined).pending === undefined) {
          return Curry._1(t.emit, {
            TAG: /* Remove */ 1,
            _0: member._0
          });
        } else {
          return;
        }
      default:
        return;
    }
  }
}

function create(emit, model, path, failure, allowed) {
  return {
    emit,
    model,
    path,
    failure,
    allowed,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
